import type { IV3ParsedData } from "./v3";

interface ICompletionsData {
    people: {
        id: string;
        name: string;
        teamName: string;
        orgName: string;
        groupName: string;
    }[];
    tasks: { id: string; name: string }[];
    completions: Map<string, Map<string, boolean>>;
    pastDeadlines: Map<string, Map<string, boolean>>;
    miles: Map<string, number> | undefined;
    counts: Map<string, Map<string, number>> | undefined;
    totals: Map<string, number>;
    state: {
        showNames: boolean;
        rowsPerColumn: number;
        groupBy: "person" | "group" | "org" | "team";
    };
}

interface IMilesBarData {
    chartData: {
        label: string;
        value: number;
    }[];
    checkpoint: number;
    goal: number;
    deadlineGoal: number;
}

interface IMilesLineData {
    chartData: (
        | {
              label: number;
              deadline: number;
          }
        | Record<string, number>
    )[];
    state: {
        yAxis: "total" | "average" | "team" | "group" | "org";
        xAxis: "day" | "week" | "month";
        relative: "calendar" | "path";
        linesDeadline: boolean;
        maxTicks: number;
    };
    teams: {
        id: string;
        name: string;
    }[];
    groups: {
        id: string;
        name: string;
    }[];
    orgs: {
        id: string;
        name: string;
    }[];
    checkpoint: number;
    goal: number;
}

interface ITaskCountLineData {
    chartData: (
        | {
              label: number;
          }
        | Record<string, number>
    )[];
    state: {
        xAxis: "day" | "week" | "month";
        relative: "calendar" | "path";
        maxTicks: number;
        dataLabels: boolean;
    };
    tasks: {
        id: string;
        name: string;
    }[];
    numMembers: number;
}

export type V4ChartDatum =
    | { chart: "miles-bar"; data: IMilesBarData; heading: string }
    | { chart: "miles-line"; data: IMilesLineData; heading: string }
    | { chart: "task-count"; data: ITaskCountLineData; heading: string }
    | { chart: "completions-table"; data: ICompletionsData; heading: string };

export interface IV4ParsedData {
    charts: V4ChartDatum[];
    version: 4;
    name: string;
}

export function v3tov4(v3Data: IV3ParsedData): IV4ParsedData {
    const v4Data: IV4ParsedData = {
        name: v3Data.name,
        version: 4,
        charts: v3Data.charts.map((chartDatum) => {
            if (chartDatum.chart === "task-count") {
                return {
                    ...chartDatum,
                    data: {
                        ...chartDatum.data,
                        tasks: chartDatum.data.tasks.map((task) => ({
                            id: task.id,
                            name: task.shortTitle,
                        })),
                    },
                };
            }
            if (chartDatum.chart === "completions-table") {
                return {
                    ...chartDatum,
                    data: {
                        ...chartDatum.data,
                        tasks: chartDatum.data.tasks.map((task) => ({
                            id: task.id,
                            name: task.shortTitle,
                        })),
                    },
                };
            }
            return chartDatum;
        }),
    };
    return v4Data;
}
